<template>
	<div class="overlay-backdrop">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'OverlayBackdrop'
};
</script>

<style lang="scss" scoped>
.overlay-backdrop {
	background: $backdrop-bkgd;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	position: fixed;
	-webkit-transition: opacity 400ms ease-in;
	-moz-transition: opacity 400ms ease-in;
	transition: opacity 400ms ease-in;
	display: flex;
	opacity: 1;
	pointer-events: auto;
	z-index: 9000;
}
</style>
